module.exports = __webpack_public_path__ + "img/IMG-20200910-WA0002.03e4d1e3.jpg";